module.exports = __webpack_public_path__ + "media/promo/promo/images/bg-3-11cb99d701cd05b0d1addc1959afac74.png";